
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...url_slugs]",
      function () {
        return require("private-next-pages/[...url_slugs]/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...url_slugs]"])
      });
    }
  